import { Component } from "react";

export class IdentificacionesAsociadas extends Component {


    render() {
        const identificaciones = this.props.Identificaciones;

        return (
            <div id="IdentificacionesAsociadas" className="card shadow mb-4">
                <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">{this.props.Titulo}</h6>
                </div>
                <div className="card-body">
                    <table id="tbIdentificaciones" className="table table-sm">
                        <thead className="table-primary">
                            <tr>
                                <th>Tipo Persona</th>
                                <th>Identificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                               Object.keys(identificaciones).length > 0? identificaciones.map((item, index) =>
                                    <tr key={index} >
                                        <td>{item.tipoPersona.descripcionLarga}</td>
                                        <td>{item.codigo}</td>
                                    </tr>
                                )
                            :
                            null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default IdentificacionesAsociadas;